
import AppDiverseLedgerEdit from "@/components/bookkeeping/DiverseEditLedgersCard.vue";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { TranslateResult } from "vue-i18n";
import { DiverseLedger } from "@/models/base";

export default Vue.extend({
	data() {
		return {
			id: 0,
			ledger: new DiverseLedger(),
		};
	},
	computed: {
		title(): TranslateResult {
			return ToolbarService.title;
		}
	},
	methods: {
		async onCancel() {
			await this.$router.push("/diverse-ledgers");
		},
		async onRefresh() {
			this.$emit("refresh");
			await this.$router.push("/diverse-ledgers");
		}
	},
	async mounted() {
		this.id = parseInt(this.$route.params.id);

		if (this.id) {
			ToolbarService.title = this.$ct("edit-diverse-ledger");
		} else {
			ToolbarService.title = this.$ct("new-diverse-ledger");
		}
	},
	created() {
		if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)) {
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppDiverseLedgerEdit
	},
	i18nEx: {
		componentPrefix: "components.diverse-ledgers"
	}
});
